export const FormLabel = {
  baseStyle: {
    fontSize: '14px',
    fontWeight: '600',
  },
}
